import React from 'react';
import { Box, Typography } from '@mui/material';
import SortSelection from './SortSelection';
import ItemsPerPage from './ItemsPerPage';

interface ProductsToolbarProps {
  // Product count
  productItemCount: number;

  // Sort functionality
  currentSort: string;
  onSortChange: (sortValue: string) => void;

  // Items per page functionality
  currentItemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;

  // Pagination functionality
  totalPages: number;
  currentPage: number;
  previousPage: () => void;
  nextPage: () => void;
  lastPage: () => void;
  firstPage: () => void;

  // Loading state
  isLoading?: boolean;

  // Show All mode
  showAll?: boolean;
}

const ProductsToolbar: React.FC<ProductsToolbarProps> = ({
                                                           productItemCount,
                                                           currentSort,
                                                           onSortChange,
                                                           currentItemsPerPage,
                                                           onItemsPerPageChange,
                                                           totalPages,
                                                           currentPage,
                                                           previousPage,
                                                           nextPage,
                                                           lastPage,
                                                           firstPage,
                                                           isLoading = false,
                                                           showAll = false
                                                         }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        py: 2,
        px: 1,
        mb: 3
      }}
    >
      {/* Left side - Product count */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: 'text.primary',
          minWidth: 'fit-content'
        }}
      >
        {productItemCount} Products {showAll && '(Showing All)'}
      </Typography>

      {/* Pagination + Items per page — right-aligned so items-per-page sits
          next to Sort instead of stranded in the middle. */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 3,
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          flex: 1
        }}
      >
        {/* Items per page (pagination lives only at the bottom, like trade) */}
        <ItemsPerPage
          currentItemsPerPage={currentItemsPerPage}
          onItemsPerPageChange={onItemsPerPageChange}
          isLoading={isLoading}
          showAll={showAll}
        />
      </Box>

      {/* Right side - Sort Selection */}
      <SortSelection
        currentSort={currentSort}
        onSortChange={onSortChange}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ProductsToolbar;